"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonPager_en_us = void 0;
function commonPager_en_us() {
    return {
        "pager.back": "back",
        "pager.next": "next",
        "pager.more": "more",
        "pager.itemsperpagelabel": "Items per Page",
        "pager.firstpagelabel": "First Page",
        "pager.nextpagelabel": "Next Page",
        "pager.previouspagelabel": "Previous Page",
        "pager.lastpagelabel": "Last Page",
        "pager.of": "of"
    };
}
exports.commonPager_en_us = commonPager_en_us;
